import { http } from "@/service/http";

/**
 * 提交任务
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const submitTask = ({ action, prompt, taskId, index, base64 }) => {
  return http.post("/chat/submit_1", {
    action,
    prompt,
    taskId,
    index,
    base64,
  });
};

/**
 * 上传图片
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const upload = (data) => {
  return http.post("/chat/upload", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * 查询指定任务
 * @param renwu_id
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const queryTask = ({ renwu_id }) => {
  return http.post("/chat/chaxun_renwu", {
    renwu_id,
  });
};

/**
 * 查询我的创作
 * @param page
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const getMyProduct = ({ page = 1 }) => {
  return http.post("/chat/zuijin_renwu", {
    page,
  });
};

/**
 * 查询广场
 * @param page
 * @param leixing
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const getSquare = ({ page = 1, leixing = 0 }) => {
  return http.post("/chat/tuijian_liebiao", {
    page,
    leixing,
  });
};

/**
 * 点赞
 * @param id
 * @param love
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const like = (id, love) => {
  return http.post("/chat/xihuan", {
    renwu_id: id,
    love,
  });
};

/**
 * 分享
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const share = (id) => {
  return http.post("/chat/fenxiang_tupian", {
    renwu_id: id,
  });
};

/**
 * 删除
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const del = (id) => {
  return http.post("/chat/shanchu_zuoping", {
    renwu_id: id,
  });
};

/**
 * 收藏
 * @param id
 * @param love
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const collect = (id, love = 1) => {
  return http.post("/chat/shouchang", {
    renwu_id: id,
    love,
  });
};

export const getMyCollectAndLoves = ({ page, leixing }) => {
  return http.post("/chat/shouchang_liebiao", {
    page,
    leixing,
  });
};

export const getUserInfo = () => {
  return http.post("/user/info");
};

export const getVipList = () => {
  return http.post("/order/getVipList");
};

export function createOrderApi(data) {
  return http.post("/order/createOrder", data);
}
export function checkPayApi(data) {
  return http.post("/order/checkPay", data);
}

export function logout() {
  return http.get("/user/logout");
}
